import { isRouteErrorResponse, useRouteError } from "react-router-dom";

export interface RouteErrorCopy {
  title: string;
  detail: string;
}

export function routeErrorCopy(error: unknown): RouteErrorCopy {
  if (isRouteErrorResponse(error)) {
    if (error.status === 401) {
      return {
        title: "登录状态已失效",
        detail: "请回到主系统重新进入，或返回工作台重新配置访问密钥。",
      };
    }
    if (error.status === 403) {
      return {
        title: "没有权限查看本页",
        detail: "当前访问凭证不包含这个页面，请从有权限的业务入口重新打开。",
      };
    }
    if (error.status === 404) {
      return {
        title: "页面不存在或已移动",
        detail: "当前地址没有可显示的内容，请返回工作台重新选择入口。",
      };
    }
    if (error.status >= 500) {
      return {
        title: "本页暂时无法显示",
        detail: "服务响应异常。可先重新加载；若仍失败，请稍后再试。",
      };
    }
  }

  return {
    title: "本页未能显示",
    detail: "页面加载或渲染时发生异常。当前地址已保留，可重新加载后继续。",
  };
}

export function RouteErrorPage() {
  const copy = routeErrorCopy(useRouteError());

  return (
    <main className="grid min-h-screen place-items-center bg-canvas px-4 py-10 text-ink">
      <div className="grid w-full max-w-3xl overflow-hidden rounded-lg border border-stroke-1 bg-surface shadow-lg md:grid-cols-[9rem_1fr]">
        <aside className="flex flex-row items-center gap-4 border-b border-danger/20 bg-danger-soft px-6 py-5 text-danger md:flex-col md:items-start md:border-b-0 md:border-r md:px-5 md:py-8">
          <span className="grid h-10 w-10 shrink-0 place-items-center rounded-md border border-danger/25 bg-surface">
            <span className="text-lg font-semibold" aria-hidden="true">
              !
            </span>
          </span>
          <div>
            <p className="text-xs font-medium tracking-[0.16em]">页面状态</p>
            <p className="mt-1 text-sm font-semibold">显示中断</p>
          </div>
        </aside>

        <section className="px-6 py-7 sm:px-9 sm:py-9">
          <h1 className="text-xl font-semibold tracking-tight text-ink">
            {copy.title}
          </h1>
          <p className="mt-3 max-w-xl text-sm leading-6 text-ink-2">
            {copy.detail}
          </p>

          <div className="mt-7 flex flex-wrap gap-3">
            <button
              type="button"
              className="inline-flex h-10 items-center justify-center rounded-md bg-brand px-4 text-sm font-medium text-surface transition-colors hover:bg-brand-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-2"
              onClick={() => window.location.reload()}
            >
              重新加载本页
            </button>
            <a
              href="/"
              className="inline-flex h-10 items-center justify-center rounded-md border border-stroke-2 bg-surface px-4 text-sm font-medium text-ink transition-colors hover:bg-surface-2 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-accent focus-visible:ring-offset-2"
            >
              返回工作台
            </a>
          </div>

          <p className="mt-6 border-t border-stroke-1 pt-4 text-xs leading-5 text-ink-3">
            若问题持续出现，请记录当前页面地址与发生时间后联系系统管理员。
          </p>
        </section>
      </div>
    </main>
  );
}
